import styled from 'styled-components';

const Text = styled.p`
    color: ${props => props.primary ? '#373737' : '#fff'};
    font-size: ${props => props.fontSize || '16px'};
    font-weight: ${props => props.fontWeight || '400'};
    text-align: ${props => props.textAlign || 'inherit'};
`;

export default Text;


// WEBPACK FOOTER //
// ./src/components/Text.js